import { Button, Form, InputGroup, Modal } from 'react-bootstrap'
import { useContext, useState } from 'react';
import { Eye, EyeSlash } from 'react-bootstrap-icons'
import { User } from '../api/User';
import { GlobalContext } from '../App';
import { ANONYMOUS_HANDLE } from './helpers';

/**
 * Display the login modal and handle login 
 * and logout
 * 
 * @param {*} param0 
 * @returns 
 */
export default function LoginModal({ open, setOpen, afterLogin }) {
  const global = useContext(GlobalContext)
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const handleLogin = (e) => {
    e.preventDefault()
    setLoading(true)
    const originalUser = global.user
    const data = { email: username, handle: username, password }
    User.login(global, data)
      .then(() => {
        setOpen(false)
        afterLogin && afterLogin(originalUser)
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false))
  }

  const handleLogout = () => {
    User.logout(global)
      .then(() => setOpen(false))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      show={open}
      onHide={() => setOpen(false)}
      dialogClassName="bottom-modal-dialog"
      contentClassName="rounded-top"
      backdropClassName="modal-backdrop"
      centered
      fullscreen="sm-down"
    >
      <Modal.Header closeButton>
        {global.user && global.user.handle !== ANONYMOUS_HANDLE ?
          <div className="px-3">
            Signed in as {global.user.name()}{"  "}
            <Button
              variant="link"
              onClick={handleLogout}
              className="p-0 align-baseline"
            >
              Sign Out
            </Button>
          </div>
          : "Sign in to Trubbl"}
      </Modal.Header>
      <Modal.Body>
        <div className="px-3">
          {!error ? null : <p>{error}</p>}
          {global.user && global.user.handle !== ANONYMOUS_HANDLE ?
            <h4 className="mt-1">Sign in as New User</h4>
            : null}
          <Form onSubmit={handleLogin}>
            <Form.Group className="mt-3" controlId="username">
              <Form.Control
                type="text"
                name="username"
                placeholder="Email or handle"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="p-3"
              />
            </Form.Group>

            <Form.Group className="mt-4" controlId="password">
              <InputGroup>
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="p-3"
                  style={{ borderRight: "none" }}
                />

                <Button
                  disabled={loading}
                  style={{ borderLeft: "none", backgroundColor: "transparent", borderColor: "#DEE2E6" }}
                  className="trubbl-color"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? <EyeSlash /> : <Eye />}
                </Button>
              </InputGroup>
            </Form.Group>

            <div className="text-center mt-3">
              <Button variant="primary" type="submit" style={{ minWidth: "125px" }}>
                Sign In
              </Button>
            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  )
}

/**
 * Show the user signin
 * @returns 
 */
export function UserDisplay({ afterLogin }) {
  const global = useContext(GlobalContext)
  const user = global.user
  const [login, setLogin] = useState(false)

  if (!user || user.handle === ANONYMOUS_HANDLE) {
    return (
      <div className="text-center">
        <p className="small-text">
          Already a Trubbl User?{"  "}
          <Button
            variant="link"
            onClick={() => setLogin(true)}
            className="p-0 align-baseline small-text"
          >
            Sign In
          </Button>
          <LoginModal open={login} setOpen={setLogin} afterLogin={afterLogin} />
        </p>
      </div>
    )
  }

  return (
    <div className="text-center">
      <p className="small-text">
        Signed in as {user.name()}{"  "}
        <Button
          variant="link"
          onClick={() => setLogin(true)}
          className="p-0 align-baseline small-text"
        >
          Change
        </Button>
      </p>
      <LoginModal open={login} setOpen={setLogin} />

    </div>
  )
}
